/** True when the member is actively in onboarding/launchpad (should see onboarding UI).
 *  Legacy members have stage='activated' → returns false. */
export const isInOnboardingStages = (stage?: string | null): boolean => stage === 'onboarding' || stage === 'launchpad';

/** True only once the member has completed onboarding and reached the activated stage.
 *  Shared by the sidebar lock and route guards so the activation predicate can't drift. */
export const isActivated = (stage?: string | null): boolean => stage === 'activated';
